import * as React from "react";
import { Typography } from "@mui/material";
import { Image, Table } from "antd";
import { useTranslation } from "react-i18next";

export const mapOrderItemsToTableRows = (items) => {
    return (items || []).map((item, index) => {
        const stockItem = item?.stockItem;
        const product = stockItem?.product || stockItem;
        return {
            key: item?._id || `${product?.sku || "item"}-${index}`,
            sku: product?.sku || product?.externalId || "-",
            image: product?.image,
            name: product?.name || "-",
            size: product?.size,
            color: product?.color,
            quantity: item?.quantityOrdered ?? 0,
        };
    });
};

export const OrderLineItemsExpandedTable = ({ items, showHeader = true, size = "small" }) => {
    const { t } = useTranslation();
    const rows = mapOrderItemsToTableRows(items);

    if (!rows.length) {
        return (
            <Typography variant="body2" sx={{ color: "var(--secColor4)", py: 1 }}>
                {t("orders.noProducts")}
            </Typography>
        );
    }

    const columns = [
        {
            title: t("inbounds.productSku"),
            dataIndex: "sku",
        },
        {
            title: t("common.image"),
            dataIndex: "image",
            render: (src) => src ? <Image width={40} height={40} src={src} preview /> : "-",
        },
        {
            title: t("common.name"),
            dataIndex: "name",
        },
        {
            title: t("common.size"),
            dataIndex: "size",
            render: (value) => value || "-",
        },
        {
            title: t("common.color"),
            dataIndex: "color",
            render: (value) => value || "-",
        },
        {
            title: t("orderDetails.quantityOrdered"),
            dataIndex: "quantity",
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={rows}
            pagination={false}
            showHeader={showHeader}
            size={size}
            rowKey="key"
        />
    );
};

export const ExchangeLineItemsExpanded = ({ outgoingItems, incomingItems }) => {
    const { t } = useTranslation();
    const hasOutgoing = (outgoingItems || []).length > 0;
    const hasIncoming = (incomingItems || []).length > 0;

    if (!hasOutgoing && !hasIncoming) {
        return <OrderLineItemsExpandedTable items={[]} />;
    }

    return (
        <>
            {hasOutgoing && (
                <>
                    <Typography variant="subtitle2" sx={{ color: "var(--secColor4)", mb: 1 }}>
                        {t("exchanges.outgoingProducts")}
                    </Typography>
                    <OrderLineItemsExpandedTable items={outgoingItems} />
                </>
            )}
            {hasIncoming && (
                <>
                    <Typography variant="subtitle2" sx={{ color: "var(--secColor4)", mt: hasOutgoing ? 2 : 0, mb: 1 }}>
                        {t("exchanges.incomingProducts")}
                    </Typography>
                    <OrderLineItemsExpandedTable items={incomingItems} />
                </>
            )}
        </>
    );
};
